import React, { Fragment, useState } from "react";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { TD } from "styled/table";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import Edit from "./Edit";
import Delete from "./Delete";

const ViewUserList = ({ emailScheduler, index }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  return (
    <Fragment>
      <tr
        key={emailScheduler._id}
        className={`${index % 2 !== 0 && "bg-gray-100"}`}
      >
        <TD>{index + 1}</TD>
        <TD>{emailScheduler.report}</TD>
        <TD>{emailScheduler.frequency}</TD>
        <TD>{emailScheduler.email}</TD>
        {/* <TD className= "stock-transfers-stencil-numbers">{emailScheduler.fleets? emailScheduler.fleets.map((item, index)=> item.fleetName + (index+1 !== emailScheduler.fleets.length ? ", ": "")): ""}</TD> */}
        <TD>
          {emailScheduler.createdAt
            ? new Date(emailScheduler.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-')
            : ""}
        </TD>
        {checkPermission([permissions.manage_users], currentUser) ?  <TD>
          <div className="">
            <button
              onClick={() => setShowEditModel(true)}
              className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
            >
              <FaEdit />
            </button>
            <button
              onClick={() => setShowDeleteModel(true)}
              className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
            >
              <FaTrash />
            </button>
          </div>
        </TD>: <TD>---</TD>}
       
      </tr>
      {showEditModel && (
        <Edit
          data={emailScheduler}
          handleClick={() => setShowEditModel(false)}
        />
      )}

      {showDeleteModel && (
        <Delete
          id={emailScheduler._id}
          handleClick={() => setShowDeleteModel(false)}
        />
      )}
    </Fragment>
  );
};

export default ViewUserList;
